(function () {
    'use strict';

    angular
        .module('szallodak-offer', []);
})();
